import { Cog } from "lucide-react";

export function SettingsHeader() {
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-full bg-orange-100">
          <Cog className="h-5 w-5 text-orange-600" />
        </div>
        <h1 className="text-xl sm:text-2xl font-bold text-orange-900">
          Innstillinger
        </h1>
      </div>
      <p className="text-sm text-orange-600/80">
        Administrer dine personlige innstillinger og preferanser
      </p>
    </div>
  );
}